import { useInfoUser } from "../../store/UserStore";
import { Avatar, Image } from "antd";
import { getColorFromInitial } from "../../utils/Utils";
import { last } from "lodash";
import { useState } from "react";
import { OnlineCircle } from "./OnlineCircle";
import { UserDetailModal } from "./UserDetailModal";
import { useCacheImage } from "../../hooks/useCacheImage";

const ProfileAvatar = () => {
  const { user } = useInfoUser();
  const { imgBlob } = useCacheImage(user?.avatar);

  const [isPreview, setIsPreview] = useState(false);
  return (
    <>
      <Avatar
        size={80}
        src={imgBlob}
        onError={() => true}
        onClick={() => setIsPreview(true)}
        style={{
          backgroundColor: getColorFromInitial(
            last(user?.name?.trim()?.split(" "))?.[0],
          ),
          color: "white",
          cursor: "pointer",
        }}
      >
        {last(user?.name?.trim()?.split(" "))?.[0]}
      </Avatar>
      {isPreview && imgBlob && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: isPreview,
            onVisibleChange: (visible) => setIsPreview(visible),
          }}
          src={imgBlob}
        />
      )}
    </>
  );
};

const MemberAvatar = ({
  person,
  size = 40,
  onlineSize = "small",
  isAction = true,
}) => {
  const [isOpenModalUserDetail, setIsOpenModalUserDetail] = useState(false);

  const { imgBlob } = useCacheImage(person?.avatar);

  const handleOpenModalUserDetail = () => {
    if (isAction) setIsOpenModalUserDetail(true);
  };

  return (
    <div className={`relative`}>
      <Avatar
        size={size}
        src={imgBlob}
        onError={() => true}
        style={{
          backgroundColor: getColorFromInitial(
            last(person?.name?.trim()?.split(" "))?.[0],
          ),
          color: "white",
          cursor: "pointer",
        }}
        onClick={handleOpenModalUserDetail}
      >
        {last(person?.name?.trim()?.split(" "))?.[0]}
      </Avatar>

      <OnlineCircle userId={person?.userId} size={onlineSize} />
      {isOpenModalUserDetail && (
        <UserDetailModal
          person={person}
          isOpen={isOpenModalUserDetail}
          handleCancel={() => setIsOpenModalUserDetail(false)}
        />
      )}
    </div>
  );
};

export { ProfileAvatar, MemberAvatar };
